<!-- @Author: Yu_Bo -->
<template>
	<div class='role_member'>
		<!-- 标题 -->
		<div class="vue_title_txt">
      <span class="title">角色管理</span>
      <span class="line">/</span>
      <span class="tip">成员管理</span>
    </div>
    <!--  -->
    <!--  -->
    <div class="role_main">
      <!--  -->
      <div class="main_condition">
        <div class="cond_left">
          <el-input v-model="role_name" size="small" @keyup.enter.native="search" @clear='search' :clearable="true" placeholder="请输入账号"></el-input>
        </div>
      </div>
      <!--  -->
      <div class="main_table">
        <el-table :data="list" v-loading="loading" style="width: 100%"
          header-cell-class-name="table-header" cell-class-name="cell-class">
          <template slot="empty">
            <empty-data img='no_img_b.png' text='暂无数据'></empty-data>
          </template>
          <el-table-column prop="mobile" label="账号"></el-table-column>
          <el-table-column prop="role.name" label="角色"></el-table-column>
          <el-table-column prop="nickname" label="名称"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column prop="update_time" label="更新时间"></el-table-column>
          <el-table-column prop="" label="最后登录">
            <template slot-scope="scope">
              <span>{{scope.row.last_time || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="switch" label="是否启用">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value='1' :inactive-value='2' :key="scope.row.id" @change="changeSwitch($event,scope.row,scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column class-name="last_class" label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="addEditBtn(2,scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="delBtn(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="page_box" v-if="total">
        <paging-page :total='total' align='right' @sizeChange='sizeChangeBtn' @currentChange='currentChangeBtn'></paging-page>
      </div>
    </div>
    <!-- 删除提示 -->
    <point-out ref='dialogTip' dialogTitle="提示" type="memberDel" @close='closeListBtn' dialogWidth='420px' :iconShow='true' iconColor='#FF7432' borderRadius='10px' :cancelShow='true' :affirmShow='true'>
      <div class="zc_dialog_tip_content">
        <div class="text">删除该账号后不能再登录，确定要删除该成员吗？</div>
      </div>
    </point-out>
    <!-- 编辑 -->
    <member-edit ref="dialogMember" :type="account_type" :roleList="options" @submit='submitBtn'></member-edit>
	</div>
</template>

<script>
	import PointOut from '@/components/point_out/point_out.vue'//提示
	import EmptyData from '@/components/empty_data/empty_data.vue'//空数据
	import PagingPage from '@/components/paging_page/paging_page.vue'//分页
  import MemberEdit from '../components/member_edit/member_edit.vue'//编辑
	export default {
		components: {PointOut, EmptyData, PagingPage, MemberEdit},
		props: {},
		data() {
			return{
        id:'',
        role_name:'',
        options:[],
        //
        list:[],
        loading:false,
        //
        page: 1,
        limit: 10,
        total:0,
        // 删除
        del_index:'',
        // 编辑
        account_type:2,
			}
		},
		computed: {},
		watch: {},
		created() {
      if(this.$route.query.id){
        this.id=this.$route.query.id
        this.paramsInfo()
        this.search()
      }
    },
		mounted() {},
		methods: {
      paramsInfo(){
        var that= this
        that.$purviewApi.systemUserParams({status:1}).then(res => {
          if (res.code == 1000) {
            that.options=res.result.role
          } else {
            that.$errMsg(res.message)
          }
        })
      },
      search() {
      	this.page = 1
      	this.list = []
      	this.total = 0
      	this.getList()
      },
      // 列表
      getList(){
        var that = this
        that.loading=true
        var params = {
          role_id:that.id,
          mobile:that.role_name,
          page: that.page,
          limit: that.limit,
        }
        that.$purviewApi.systemUser(params).then(res => {
          that.loading = false
          if (res.code == 1000) {
            that.list=res.result?.data
            that.total=res.result?.total
          } else {
            that.$errMsg(res.message)
          }
        })
      },
      // 修改状态
      changeSwitch(val,info,index){
       var that = this
       var params = {
         id: info.id,
         status: val,
       }
       that.$purviewApi.systemUserStatus(params).then(res => {
         if (res.code == 1000) {
           that.$succMsg(res.message)
           that.list[index].status=val
         } else {
           that.list[index].status=val==1?2:1
           that.$errMsg(res.message)
         }
       })
      },
      // 编辑
      addEditBtn(type,info){
        this.account_type=type
        console.log(info)
        this.$refs.dialogMember.openDialogBtn(info)
      },
      // 删除
      delBtn(index){
        this.del_index=index
        this.$refs.dialogTip.openDialogBtn()
      },
      closeListBtn(){
        var that = this
        if(that.del_index!==''){
          that.$purviewApi.deleteSystemUser('',that.list[that.del_index].id).then(res => {
            if (res.code == 1000) {
              that.$succMsg(res.message)
              that.getList()
            } else {
              that.$errMsg(res.message)
            }
          })
        }
      },
      // 改变每页条数
      sizeChangeBtn(val){
        this.limit = val
        this.page = 1
        this.getList()
      },
      // 改变页数
      currentChangeBtn(val){
        this.page = val
        this.getList()
      },
      // 编辑=确定
      submitBtn(){
        this.getList()
      },
    },
	}
</script>

<style lang='scss' scoped>
	.role_member{
    width: 100%;
    .role_main{
      width: 100%;
      padding: 0 20px;
      .main_condition{
        width: 100%;
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .cond_left{
          display: flex;
          align-items: center;
          .el-button{
            padding: 8px 10px;
            margin-right: 20px;
          }
          .el-select{
            margin-right: 20px;
            width: 160px;
          }
          .el-input{
            margin-right: 20px;
            width: 160px;
          }
        }
        .cond_right{
          .el-button{
            padding: 8px 10px;
          }
        }
      }
    }
	}
</style>
